import { useContext } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png'
import logo_worded_only from '../assets/logo_worded_only.png'
import { MdArrowDropDown, MdBuild, MdDashboard, MdHome, MdHotel, MdHouse, MdMoney, MdOutlineAnalytics, MdOutlineDashboard, MdOutlinePayment, MdOutlinePayments, MdOutlineSpaceDashboard, MdPayments, MdPeople, MdShop, MdSubject, MdViewList } from "react-icons/md";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { GoPerson } from "react-icons/go";
import { IoMdCash } from "react-icons/io";


export default function SideBar(props) {

  const appContext = useContext(AppContext);



  return (
    <div
      className="SideBar"
      data-open={appContext.isSideBarOpen}
    >
      <div className="body mNoScrollBar">

        {/*
        <div className="logo-holder">
          <img
            src={logo}
          />
        </div>
        */}
        
        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'dashboard'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'dashboard') || !appContext.navItem}
          
        >
          <MdDashboard className="icon" />
          <p className="text">Dashboard</p>
        </div>
      

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'classrooms'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'classrooms')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Classrooms</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'subjects'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'subjects')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Subjects</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'students'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'students')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Students</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'general_payment_cycles'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'general_payment_cycles')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">General Payment Cycles</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'individual_payment_cycles'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'individual_payment_cycles')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Individual Payment Cycles</p>
        </div>

        {/*
        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'examination_cycles'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'examination_cycles')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Examination Cycles</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'academic_terms'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'academic_terms')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Academic Terms</p>
        </div>
        */}

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'staff'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'staff')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Staff</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'accounting'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'accounting')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Accounting</p>
        </div>

        {/*
        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'reports'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'reports')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Reports</p>
        </div>
        */}

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'grading_systems'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'grading_systems')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Grading Systems</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'my_activities'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'my_activities')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">My Activities</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'parental_communications'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'parental_communications')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Parental Communications</p>
        </div>
        
      </div>
    </div>
  )
}